<template>
  <main>
  <h2 class="ttl"><img src="/img/ico_pw2.png" alt="パスワード" width="40" class="mb30"><br>{{$t('accountPassword')}}</h2>
    <div class="account-box">
      <p class="txt-pw">
        <span v-if="!$v.newPassword.required || !$v.newPassword.required || !$v.newPassword.minLength || !$v.newPassword.maxLength ||!$v.newPassword.alphaNum || !$v.newPassword.match">
          {{$t(this.getMessage($v.newPassword , {"name" : "新しいパスワード" , "type" : "OnebyOne"}))}}
        </span>
        <span class="txt-info">
         {{$t('passwordRequirement')}}
        </span>
        <input type="password" id="pw" name="pw" placeholder="Password" v-model.trim="$v.newPassword.$model">
      </p>
      <p class="txt-pw">
        <span v-if="!$v.newPasswordVerify.verifyPassword ">{{$t(this.getMessage($v.newPasswordVerify))}}</span>
        <input type="password" id="pw" name="pw" placeholder="Password" v-model="$v.newPasswordVerify.$model">
      </p>
    </div>
    <p class="txt-error center mb40">
      <validationError :error="(this.$v.$invalid && this.vaError)"/>
      <firebaseError :error="this.fbError" :errorCode="errorCode"/>
    </p>
    <p class="btn-normal">
      <router-link to="" @click.native="updatePassword">{{$t('update')}}</router-link>
    </p>
    <modal name="input-password" :adaptive="true" width="100%" height="100%" :clickToClose="false">
      <h2 class="ttl">{{$t('currentPassword')}}</h2>
      <div class="room-name">
        <p><input type="password" placeholder="Password" v-model="password"></p>
      </div>
      <div class="center">
        <button class="mb20" @click="modalCompleted(false)">OK</button>
        <button class="cancel" @click="modalCompleted(true)">{{$t('cancel')}}</button>
      </div>
    </modal>
  </main>
</template>

<script>
import firebase from 'firebase'
import firebaseError from "@/error/FirebaseError"
import validationError from "@/error/ValidationError"
import { required , alphaNum ,  minLength , maxLength} from "vuelidate/lib/validators"

export default {
  name: 'AccountPasswordEdit',
  data () {
    return {
      user: firebase.auth().currentUser,
      password: '',
      newPassword: '',
      newPasswordVerify: '',
      vaError : false, //バリデーションエラー
      fbError : false, //firebaseエラー
      errorCode: "",
    }
  },
  validations: {
    newPassword: {
      required,
      minLength : minLength(8),
      maxLength : maxLength(20),
      alphaNum,
      match () {
        return this.isNotEmpty(this.isMatch(this.newPassword , 'oneByOne' ))
      }
    },
    newPasswordVerify: {
      verifyPassword : required,
    },
  },
  components: {
    firebaseError,
    validationError,
  },
  methods: {
    modalCompleted (isCancel) {
      if (isCancel) {
        this.$modal.hide('input-password')
      }
      if(!this.password) {
        return
      }
      this.$modal.hide('input-password')
      this.reauthenticate()
    },
    async updatePassword () {
      this.$v.$touch()
      if(this.$v.$invalid) {
        this.vaError = true
        return
      }
      if (this.newPassword != this.newPasswordVerify) {
        this.errorCode = "not-match-password"
        this.fbError = true
        return
      }
      try {
        await this.user.updatePassword(this.newPassword)
        this.$router.push({ name: 'AccountPasswordEditCompleted' })
      } catch(error) {
        switch(error.code) {
          case 'auth/requires-recent-login':
            this.$modal.show("input-password")
            return
          default:
            this.errorCode = error.code
            this.fbError = true
            return
        }
      }
    },
    async reauthenticate () {
      const credential = firebase.auth.EmailAuthProvider.credential(this.user.email, this.password)
      try {
        await this.user.reauthenticateWithCredential(credential)
        this.updatePassword()
      } catch(error) {
        this.errorCode = error.code
        this.fbError = true
      }
    }
  }
}
</script>
